import * as React from 'react';
import type { AnimatedValue, ForwardedProps } from 'react-spring';
import { useSpring } from 'react-spring';

export const useBoop = ({
  x = 0,
  y = 0,
  rotation = 0,
  scale = 1,
  timing = 150,
  springConfig = {
    friction: 10,
    tension: 300,
  },
}): [AnimatedValue<ForwardedProps<unknown>>, () => void] => {
  const [isBooped, setIsBooped] = React.useState(false);

  const props = useSpring({
    display: 'inline-block',
    transform: isBooped
      ? `translate(${x}px, ${y}px) rotate(${rotation}deg) scale(${scale})`
      : `translate(0px, 0px) rotate(0deg) scale(1)`,
    config: springConfig,
  });

  React.useEffect(() => {
    if (!isBooped) return;

    const timeoutId = setTimeout(() => setIsBooped(false), timing);

    return () => clearTimeout(timeoutId);
  }, [isBooped, timing]);

  const trigger = React.useCallback(() => setIsBooped(true), []);

  return [props, trigger];
};
